import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    errorsPresent: Boolean,
    jobCompleted: Boolean,
    mfaRequired: Boolean,
    errorRedirectUrl: String,
    completionRedirectUrl: String,
    mfaRedirectUrl: String,
  }

  connect() {
    if (this.errorsPresentValue) {
      window.location.href = this.errorRedirectUrlValue
    } else if (this.jobCompletedValue) {
      window.location.href = this.completionRedirectUrlValue
    } else if (this.mfaRequiredValue) {
      window.location.href = this.mfaRedirectUrlValue
    }
  }
}
